import classNames from 'classnames';
import moment from 'moment-timezone';
import { HTMLAttributes } from 'react';
import Holidays from 'date-holidays';

import TyCalDayHead from './TyCalDayHead';
import { BadgePill } from '@tymbe/ty-components/indicators';
import { useTyCalWeekData } from './TyCalWeekContext';
import { ShiftData } from '@tymbe/schema/src/shift.interface';

interface TyCalDayOfWeekProps extends HTMLAttributes<HTMLDivElement> {
  date: string;
  day: number;
}

const holidays = new Holidays('CZ');

const TyCalDayOfWeekWithBadge = ({ date, ...rest }: TyCalDayOfWeekProps) => {
  const m = moment(date);
  const now = moment();
  const day = m.get('date');
  const dayName = m.format('dddd');
  const isToday = m.isSame(now, 'day');
  const holiday = holidays.isHoliday(new Date(date));

  const inPast = m.isBefore();

  const { eventData } = useTyCalWeekData<ShiftData>();
  const dayEvents = eventData.filter(({ date: eventDate }) =>
    moment(date).isSame(eventDate, 'day')
  );

  const hasNoAttendance = dayEvents.some(
    ({ data }) =>
      data.application?.length &&
      data.application?.some(({ attendance }) => attendance === null)
  );
  return (
    <TyCalDayHead
      className={classNames(
        {
          'text-secondary-900': isToday,
          'text-secondary-400': !isToday,
          'bg-secondary-50': [0, 6].includes(m.get('day')) || holiday,
        },
        'flex flex-col justify-center'
      )}
      {...rest}
    >
      <div className="flex justify-between">
        <div className="flex h-6 gap-2 items-center text-body-2-xl font-medium capitalize">
          {dayName}{' '}
          {isToday && (
            <span className="h-2 w-2 rounded-full bg-secondary-900" />
          )}
        </div>
        {inPast && hasNoAttendance && (
          <BadgePill variant="error" className="font-medium" {...rest}>
            Docházka
          </BadgePill>
        )}
      </div>
      <div className="flex items-center gap-2">
        <span className={classNames('font-semibold text-heading-4-xl')}>
          {day}
        </span>
        <span className="text-caption-xl text-base-front-3 truncate">
          {holiday ? holiday[0]?.name : null}
        </span>
      </div>
    </TyCalDayHead>
  );
};

export default TyCalDayOfWeekWithBadge;
